import insigneAnime from '@cibli/shared/assets/insigne-vert-noir-anime.svg';
import { Speaker } from '@micdrop/web';
import { useEffect, useState } from 'react';

/**
 * Cibli logo with animated voice waves.
 * Uses a single <style> element (not injected per render).
 * Waves animate when Speaker is playing audio.
 */
export function AssistantLogo() {
  const [isSpeaking, setIsSpeaking] = useState(false);

  useEffect(() => {
    const onStart = () => setIsSpeaking(true);
    const onStop = () => setIsSpeaking(false);

    Speaker.on('StartPlaying', onStart);
    Speaker.on('StopPlaying', onStop);
    if (Speaker.isPlaying) setIsSpeaking(true);

    return () => {
      Speaker.off('StartPlaying', onStart);
      Speaker.off('StopPlaying', onStop);
    };
  }, []);

  return (
    <div className="relative shrink-0 h-12 w-12" aria-hidden="true">
      <style>{`
        .onde { animation-play-state: ${isSpeaking ? 'running' : 'paused'}; ${isSpeaking ? '' : 'transform: scaleY(0); transition: transform 0.3s ease;'} }
      `}</style>
      <img
        src={insigneAnime}
        alt=""
        className="h-12 w-12"
        onError={e => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    </div>
  );
}
